// Xuan Harness monogram: a calligraphic X drawn with two crossing ribbons.

import type { IconProps } from './icons/props.ts'

/**
 * Render the Xuan Harness monogram.
 * @param props.size - width in px (default 24; the glyph is square).
 * @param props.className - extra class for layout placement.
 * @returns the logo svg (aria-hidden; pair with the wordmark for accessibility).
 */
export function TurbineLogo({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2.25" y="2.25" width="19.5" height="19.5" rx="6.25" opacity="0.42" />
      <path d="M6.2 4.8c3.2 1.1 4.7 4.2 5.8 7.2 1.25 3.35 2.9 6.2 5.8 7.2" strokeWidth="2.35" />
      <path d="M17.8 4.8c-3.2 1.1-4.7 4.2-5.8 7.2-1.25 3.35-2.9 6.2-5.8 7.2" strokeWidth="2.35" />
      <path d="m12 9.9 2.1 2.1-2.1 2.1-2.1-2.1L12 9.9Z" fill="currentColor" stroke="none" />
    </svg>
  )
}
